import { Button, Checkbox, message } from "antd";
import { Input } from "antd";
import "./style.scss";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { SignInApi } from "../../../apis/SignIn";
import { useEffect, useState } from "react";
import FlowEditLogo from "../../../assets/Header/FlowEdit.svg";
import { useCookies } from "react-cookie";
import useAuthContext from "../../../hooks/useAuthContext";
import googleLogo from "../../../assets/Login/google-icon.svg";
// import { useDispatch } from 'react-redux';
// import { resetForStepWiseUserData } from '../../../redux/Reducers/userStepsDataDetailReducer';

const Login = () => {
  let navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cookies, setCookie] = useCookies(["email", "password"]);
  const [errorMsg, setErrorMsg] = useState("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const { userState, dispatcher } = useAuthContext();
  const [searchParams] = useSearchParams();
  const [lead, setLead] = useState("");
  const [logo, setLogo] = useState();
  const [allowSignUp, setAllowSignUp] = useState(false);
  // const dispatch = useDispatch();

  // const leadId = searchParams.get('leadId');

  useEffect(() => {
    async function fetchData() {
      try {
        const userResponse = await SignInApi.getSource("");
        if (userResponse.status === 200) {
          setLogo(userResponse?.data?.imageAssets?.brandImage?.imagePath?.url);
          setAllowSignUp(userResponse?.data?.featureFlag?.allowSignup);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (cookies.__MM__UE && cookies.__MM__UP) {
      setEmail(atob(cookies.__MM__UE));
      setPassword(atob(cookies.__MM__UP)); // Decoding Base64 password
      setRememberMe(true);
    }
  }, [cookies]);
  const googleLogin = useGoogleLogin({
    flow: "implicit",
    onSuccess: async (credentialResponse) => {
      const response = await SignInApi.getCredsGoogleLogin(credentialResponse);
      localStorage.setItem("user_picture", response?.data?.picture);
      let obj = {
        email: response.data.email,
        name: response.data.name,
        distributorId:
          sessionStorage.getItem("mm:dbId") || "663b39b3ab4ec46c6ebcf258",
        accessToken: credentialResponse.access_token,
        firstName: response.data.given_name,
        lastName: response.data.family_name,
      };
      const userResponse = await SignInApi.userGoogleLogin(obj);

      if (userResponse.status === 200) {
        let user = {
          userEmail: obj.email,
          userName: obj.name,
          userToken: userResponse?.data?.token,
          userId: userResponse?.data?.userId,
          isInternal: userResponse?.data?.isInternalUser,
          isSourceAdmin: userResponse?.data?.isSourceAdmin,
        };
        localStorage.setItem("flowedit:user", JSON.stringify(user));
        localStorage.setItem("flowedit_token", userResponse.data.token);
        dispatcher({
          type: "LOGIN",
          payload: user,
        });
        navigate("/order-list");
      }
    },
  });
  const handleUserLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      message.error("Please enter all the value");
      return;
    }
    if (!emailRegex.test(email)) {
      setErrorMsg("Please enter correct email");
      return;
    }
    try {
      let payload = {
        email: email,
        password: password,
      };
      const result = await SignInApi.loginUser(payload);
      if (result?.status == 200) {
        if (rememberMe) {
          setCookie("__MM__UE", btoa(email), {
            path: "/",
            secure: true,
            maxAge: 3600,
          });

          setCookie("__MM__UP", btoa(password), {
            path: "/",
            secure: true,
            maxAge: 3600,
          });
        } else {
          setCookie("__MM__UE", "", { path: "/" });
          setCookie("__MM__UP", "", { path: "/" });
        }
        let user = {
          userEmail: email,
          userName: email,
          userToken: result.data.token,
          userId: result?.data?.userId,
          isInternal: result?.data?.isInternalUser,
          isSourceAdmin: result?.data?.isSourceAdmin,
        };

        dispatcher({
          type: "LOGIN",
          payload: user,
        });
        localStorage.setItem("flowedit:user", JSON.stringify(user));
        localStorage.setItem("flowedit_token", result.data.token);
        navigate("/order-list");
      }
      if (result?.response?.status == 403) {
        message.error(
          result.response.data.message || "Please try again later."
        );
      }
    } catch (err) {
      const errMsg = JSON.parse(err.response.data).message;
      message.error(errMsg || "Please try again later.");
    }
  };
  const getFlowEditLogo = () => {
    return (
      <div className="logo_line">
        {logo && (
          <img src={logo} alt="logo" onClick={() => navigate("/order-list")} />
        )}
      </div>
    );
  };
  const getGoogleLogin = () => {
    return (
      <div className="google_login_line">
        <Button className="google_login_btn" onClick={googleLogin}>
          <img src={googleLogo} alt="googleIcon" className="google_icon" />
          <p> Login with Google</p>
        </Button>
      </div>
    );
  };
  const getLoginForm = () => {
    return (
      <>
        <div className="user_email">
          <label className="form_label">Email ID</label>
          <Input
            type="email"
            id="email"
            name="email"
            onChange={(e) => {
              setEmail(e.target.value);
              setErrorMsg("");
            }}
            placeholder="Your email"
            required
            className="email_input"
            value={email}
          />
          {errorMsg && <div className="error">{errorMsg}</div>}
        </div>
        <div className="user_password">
          <label className="form_label">Password</label>

          <Input.Password
            placeholder="Enter Password"
            required
            className="password_input"
            name="password"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            onPressEnter={handleUserLogin}
            value={password}
          />
        </div>
        <div className="remember_forgot">
          <Checkbox
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          >
            Remember me
          </Checkbox>
          <Link to="/forgot-password" className="forgot_password">
            Forgot Password?
          </Link>
        </div>
        <div className="continue_btn_line">
          <Button
            className={`continue_btn ${
              email.trim() && password.trim() ? "" : "disable_btn"
            }`}
            onClick={handleUserLogin}
            type="submit"
            disabled={email.trim() && password.trim() ? false : true}
          >
            <p> Login </p>
          </Button>
        </div>
      </>
    );
  };

  return (
    <div className="login_wrapper">
      <div className="direction">
        {getFlowEditLogo()}

        <div className="direction_line_1">Sign in</div>
        {/* <div className="direction_line_2">Login to continue</div> */}
        {allowSignUp && getGoogleLogin()}
        {allowSignUp && (
          <div className="direction_line_3">
            Or login using your email address
          </div>
        )}
        {getLoginForm()}
      </div>
      {allowSignUp && (
        <div className="direction_line_4">
          New User? <Link to="/signup">Create an account</Link>
        </div>
      )}
    </div>
  );
};

export default Login;
